import { AfterViewInit, Component, inject, input, ViewChild } from '@angular/core';
import { CarouselComponent } from '@shared/components/carousel/carousel.component';
import { LatestNewsSectionComponent } from './components/latest-news-section/latest-news-section.component';
import { SectionTemplateComponent } from '@templates/section-template/section-template.component';
import {
  LatestPublicationsSectionComponent,
} from './components/latest-publications-section/latest-publications-section.component';
import { ImportantDatesSectionComponent } from './components/important-dates-section/important-dates-section.component';
import { PopularSectionComponent } from './components/popular-section/popular-section.component';
import { BUTTON_TYPES } from '@shared/components/button/button-types.enum';
import {
  LatestMeetingsSectionComponent,
} from './components/latest-meetings-section/latest-meetings-section.component';
import { UntilDestroy } from '@ngneat/until-destroy';
import { IHomeResponse } from '@shared/constants/models.const';
import { BaseComponent } from '@shared/classes/base.class';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SelectCategoryComponent } from './components/select-category/select-category.component';
import { HelperService } from '../../services/helper.service';

@UntilDestroy()
@Component({
  selector: 'app-home',
  imports: [
    CarouselComponent,
    LatestNewsSectionComponent,
    SectionTemplateComponent,
    LatestPublicationsSectionComponent,
    ImportantDatesSectionComponent,
    PopularSectionComponent,
    LatestMeetingsSectionComponent,
    MatProgressSpinnerModule,
    SelectCategoryComponent,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent extends BaseComponent implements AfterViewInit {

  override pageData = input.required<IHomeResponse | any>();
  @ViewChild('selectCategory') SelectCategory!: SelectCategoryComponent;
  private HELPER: HelperService = inject(HelperService);

  get isStickyVisible() {
    return this.HELPER.selectCategoryStickyState;
  }

  protected readonly ButtonTypes = BUTTON_TYPES;

  constructor() { super();}

  ngAfterViewInit() {
    this.HELPER.selectCategoryStickyState = false;
    this.HELPER.selectCategoryHandle(this.SelectCategory);
  }
}
